import axios from 'common/bsac-api.js';
import constants from 'common/constants';
import environments from 'constant/environments';
import prototype from 'prototype/notification';

const INITIAL_VALUE = {
  categoryOptions: [],
  deletedOptions: [],
  notifications: [],
  statusOptions: [],
  pushNotificationOptions: [],
};

const state = () => Object.assign({}, INITIAL_VALUE);

const getters = {
  /**
   * カテゴリーオプションリストを取得する
   * @param {*} state
   * @returns カテゴリーリスト
   */
  categoryOptions: (state) => state.categoryOptions,
  /**
   * 削除フラグオプションリストを取得する
   * @param {*} state
   * @returns 削除フラグリスト
   */
  deletedOptions: (state) => state.deletedOptions,
  /**
   * お知らせリストを取得する
   * @param {*} state
   * @returns お知らせリスト
   */
  notifications: (state) => state.notifications,
  /**
   * ステータスオプションリストを取得する
   * @param {*} state
   * @returns ステータスリスト
   */
  statusOptions: (state) => state.statusOptions,
  /**
   * プッシュ通知オプションリストを取得する
   * @param {*} state
   * @returns ステータスリスト
   */
  pushNotificationOptions: (state) => state.pushNotificationOptions,
};

const mutations = {
  /**
   * お知らせリストをセットする
   * @param {*} state
   * @param {*} data
   */
  setResponseData(state, data) {
    // if (environments.isDevelop()) console.log(`[admin-notifications.js] setData called`);
    // if (environments.isDevelop()) console.log(`[admin-notifications.js] data.data: ${JSON.stringify(data.data, null, '\t')}`);
    // if (environments.isDevelop()) console.log(`[admin-notifications.js] data.options: ${JSON.stringify(data.options, null, '\t')}`);

    state.categoryOptions = data.options.category;
    state.deletedOptions = data.options.deleted;
    state.statusOptions = data.options.status;
    state.pushNotificationOptions = data.options.push_notification;

    state.notifications = [];
    data.data.forEach(function (notification) {
      let newNotification = new prototype.Notification();
      newNotification.setApiData(notification);
      state.notifications.push(newNotification);
    });
  },
};

const actions = {
  /**
   * お知らせを削除する
   * @param {*} param0
   * @param {*} notification お知らせ
   * @returns
   */
  destroy({ getters, rootGetters }, notification) {
    if (!notification || notification.id === constants.SELECTBOX_NOT_SELECTED.value) {
      return {
        success: false,
        status: null,
        message: '引数が不正です',
      };
    }

    const url = `${constants.ADMIN_API_URL}/notifications/${notification.id}`;
    const headers = rootGetters['admin/authHeaders'];

    // if (environments.isDevelop()) console.log(`[admin-notifications.js] destroy url: ${url}`);

    return axios
      .delete(url, headers)
      .then((response) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] update response: ${JSON.stringify(response, null, '\t')}`);
        return {
          success: true,
          status: response.status,
          message: response.data.message,
        };
      })
      .catch((error) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] update error: ${JSON.stringify(error, null, '\t')}`);
        return {
          success: false,
          status: error.status,
          message: error.message,
        };
      });
  },
  /**
   * お知らせ詳細を取得する
   * @param {*} param0
   * @param {*} notificationId 商品ID
   * @returns
   */
  getNotification({ getters, rootGetters }, notificationId) {
    let notification = new prototype.Notification();
    if (notificationId === constants.SELECTBOX_NOT_SELECTED.value) return notification;

    const headers = rootGetters['admin/authHeaders'];
    const url = `${constants.ADMIN_API_URL}/notifications/${notificationId}`;

    // if (environments.isDevelop()) console.log(`[admin-notifications.js] headers: ${JSON.stringify(headers, null, '\t')}`);
    // if (environments.isDevelop()) console.log(`[admin-notifications.js] url: ${url}`);

    return axios
      .get(url, headers)
      .then((response) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] getNotification response: ${JSON.stringify(response, null, '\t')}`);
        notification.setApiData(response.data.data);
        return notification;
      })
      .catch((error) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] getNotification error: ${JSON.stringify(error, null, '\t')}`);
        return notification;
      });
  },
  /**
   * お知らせ一覧を取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getNotifications({ commit, rootGetters }, searchCondition) {
    const headers = rootGetters['admin/authHeaders'];
    const query = searchCondition ? `?${new URLSearchParams(searchCondition).toString()}` : '';
    const url = `${constants.ADMIN_API_URL}/notifications${query}`;

    // if (environments.isDevelop()) console.log(`[admin-notifications.js] headers: ${JSON.stringify(headers, null, '\t')}`);
    // if (environments.isDevelop()) console.log(`[admin-notifications.js] query: ${JSON.stringify(query, null, '\t')}`);
    // if (environments.isDevelop()) console.log(`[admin-notifications.js] url: ${url}`);

    return axios
      .get(url, headers)
      .then((response) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] getNotifications response: ${JSON.stringify(response, null, '\t')}`);
        commit('setResponseData', response.data);
        return {
          success: true,
          status: null,
          message: null,
        };
      })
      .catch((error) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] getNotifications error: ${JSON.stringify(error, null, '\t')}`);
        return {
          success: false,
          status: null,
          message: null,
        };
      });
  },
  /**
   * お知らせを登録する
   * @param {*} param0
   * @param {*} notification お知らせ
   * @returns
   */
  register({ getters, rootGetters }, notification) {
    if (!notification || notification.id !== constants.SELECTBOX_NOT_SELECTED.value) {
      return {
        success: false,
        status: null,
        message: '引数が不正です',
      };
    }

    const url = `${constants.ADMIN_API_URL}/notifications`;
    const headers = rootGetters['admin/authHeaders'];
    const requestBody = notification.getRequestBody();

    return axios
      .post(url, requestBody, headers)
      .then((response) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] register response: ${JSON.stringify(response, null, '\t')}`);
        return {
          success: true,
          status: response.status,
          message: response.data.message,
        };
      })
      .catch((error) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] register error: ${JSON.stringify(error, null, '\t')}`);
        return {
          success: false,
          status: error.status,
          message: error.data.message,
        };
      });
  },
  /**
   * お知らせを更新する
   * @param {*} param0
   * @param {*} notification お知らせ
   * @returns
   */
  update({ getters, rootGetters }, notification) {
    if (!notification || notification.id === constants.SELECTBOX_NOT_SELECTED.value) {
      return {
        success: false,
        status: null,
        message: '引数が不正です',
      };
    }

    const url = `${constants.ADMIN_API_URL}/notifications/${notification.id}`;
    const headers = rootGetters['admin/authHeaders'];
    const requestBody = notification.getRequestBody();

    // if (environments.isDevelop()) console.log(`[admin-notifications.js] update url: ${url}`);

    return axios
      .patch(url, requestBody, headers)
      .then((response) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] update response: ${JSON.stringify(response, null, '\t')}`);
        return {
          success: true,
          status: response.status,
          message: response.data.message,
        };
      })
      .catch((error) => {
        // if (environments.isDevelop()) console.log(`[admin-notifications.js] update error: ${JSON.stringify(error, null, '\t')}`);
        return {
          success: false,
          status: error.status,
          message: error.message,
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
